module.exports = __webpack_public_path__ + "static/home-a04ba13b33f6f2f840c7c6315f1a85ec.png";